import SelectLanguageModal from 'components/SelectLanguageModal';
import {useState, useContext} from 'react';
import {useClient} from '@adamlip/okeoke.client';
import {AppParamsContext} from 'contexts/AppParamsContext';
import IconComponent from 'components/IconComponent';

export default function LanguageSelector({isGrid}) {
  const {appParams} = useContext(AppParamsContext);
  const [languageModalOpen, setLanguageModalOpen] = useState(false);
  const {languageCode, languages} = useClient();

  return (
    <>
      <SelectLanguageModal isOpen={languageModalOpen} onOpenChange={setLanguageModalOpen} />
      <div
        className={`${
          isGrid ? 'w-14 h-14' : 'w-full max-w-[300px] mx-auto h-14'
        } flex shrink-0 justify-center items-center p-2 rounded-[var(--general-border-radius)] bg-primary/20`}
        onClick={() => setLanguageModalOpen(true)}>
        {appParams?.styles?.languages?.[languages?.[languageCode?.toUpperCase()]?.flagCode || 'hu'] ? (
          <div className='h-8'>
            <IconComponent iconCode={appParams?.styles?.languages?.[languages?.[languageCode?.toUpperCase()]?.flagCode || 'hu']} />
          </div>
        ) : (
          <img src={`https://cdn.okeoke.io/global/flags/${languages?.[languageCode?.toUpperCase()]?.flagCode || 'hu'}.svg`} alt='enflag' className='h-8' />
        )}
        {!isGrid && <div className='ml-2 text-primary font-bold'>{languages?.[languageCode?.toUpperCase()]?.name}</div>}
      </div>
    </>
  );
}
